<template>
	<div class="change-form">
		<div slot="header" class="header">
			<h4>Change Password</h4>
		</div>
		<div class="change-section">
			<h5>Current Password</h5>
			<el-input placeholder="Please input" v-model="origPassword" show-password size="small">
			</el-input>
			<h5>New Password</h5>
			<el-input placeholder="Please input" @focus="setValidation" @blur="removeValidation" v-model="newPassword" show-password size="small">
			</el-input>
			<div v-if="showValidation" class="validation">{{ validationText }}</div>
			<ChangeButtons @change="passwordChange" @cancel="cancel" ></ChangeButtons>
		</div>
    </div>
</template>

<script>
import validatePassword from '../../util/valid-password'
import ChangeButtons from './ChangeButtons'

export default {
	name: 'change-password',

	data() {
		return {
			origPassword: null,
			newPassword: null,
			showValidation: false
		}
    },
	watch: {
		newPassword(value) {
            if (validatePassword(value) == false)
                this.showValidation = true
            else
                this.showValidation = false
		}
	},
    methods: {
        passwordChange() {
			this.$emit('change', {
				origPassword: this.origPassword,
				newPassword: this.newPassword
			})
		},
		cancel() {
			this.$emit('cancel')
		},
		removeValidation() {
			this.showValidation = false
		},
		setValidation() {
			if (validatePassword(this.newPassword) == false)
                this.showValidation = true
            else
                this.showValidation = false
		}
	},
	computed: {
        validationText() {
            return 'Please type in at least 6 characters'
        }
	},
    components: {
        ChangeButtons
    }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>